module.exports = __webpack_public_path__ + "RMR FSA Guía de Inscripcion.pdf";